var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 472.56 199.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec8365;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Errorscreen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m472.07,146.68c-57.85,84.76-143.4,12.53-223.69,23.59-70.2,9.67-149.93,42.94-210.85,23.51C-1.43,181.35-5.56,145.66,4.98,87.25,28.32-41.98,127.37,7.64,183.89,17.93c94.55,17.21,172.74,79.37,264.59,109.28,10.87,3.54,27.11,10.76,23.59,19.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.a1d0255b9e3b72723817b7eedfc12ddd.svg";
export { ForwardRef as ReactComponent };